import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileFind = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon / file-find",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M13.707 2.293C13.6143 2.19996 13.5041 2.12617 13.3828 2.07589C13.2614 2.0256 13.1313 1.99981 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20.0002 8.86866 19.9744 8.73857 19.9241 8.61724C19.8738 8.4959 19.8 8.38571 19.707 8.293L13.707 2.293ZM6 4H12.586L18 9.414L18.002 18.588L15.434 16.02C15.784 15.425 16 14.739 16 14C16 11.794 14.206 10 12 10C9.794 10 8 11.794 8 14C8 16.206 9.794 18 12 18C12.739 18 13.425 17.784 14.02 17.434L16.586 20H6V4ZM12 16C10.897 16 10 15.103 10 14C10 12.897 10.897 12 12 12C13.103 12 14 12.897 14 14C14 15.103 13.103 16 12 16Z",
			fill: "black"
		})
	})
});
export default SvgFileFind;
